import { useGlobalState } from "./globalState";

export const useCurrentPortfolioId = () => {
  const [portfolioId, setPortfolioId] = useGlobalState("portfolioId");
  return { portfolioId, setPortfolioId };
};
